module.exports = __webpack_public_path__ + "static/media/logout-blue.fe68feeb.svg";